import {useState, useEffect} from 'react';
import { Grid, Button, Typography } from '@mui/material';
import FoodcompositionPage from 'components/foodcomposition/page/FoodcompositionPage';

export default function AddFoodCompActionImpl(){

    return (
        <>
          <FoodcompositionPage />
          
        </>
    )
}